import api from "@/config/apiConfig"

class CompanyController {

  async create ( req ) {
    try {
      const response = await api.post( `/company`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no CompanyController.create: ", error );
      throw error;
    }
  }

  async index () {
    try {
      const response = await api.get( `/company` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no CompanyController.index: ", error );
      throw error;
    }
  }

  async getChildren() {
    try {
      const response = await api.get( `/company/whitelabel/children` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no CompanyController.getChildren: ", error );
      throw error;
    }
  }

  async update ( form ) {
    try {
      const response = await api.put( `/company/${form.id}`, form );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no CompanyController.update: ", error );
      throw error;
    }
  }

  async show ( id ) {
    try {
      const response = await api.get( `/company/${id}` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no CompanyController.show: ", error );
      throw error;
    }
  }

  async getAvailableLimits () {

    try {
      const response = await api.get( `/company/whitelabel/available` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no CompanyController.getAvailableLimits: ", error );
      throw error;
    }
  }

  async configureDomain ( id, domain ) {
    try {
      const response = await api.post( `/company/${id}/domain`, { domain } );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no CompanyController.configureDomain: ", error );
      throw error;
    }
  }

  async checkDomainStatus ( id ) {
    try {
      const response = await api.get( `/company/${id}/domain/status` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no CompanyController.checkDomainStatus: ", error );
      throw error;
    }
  }

  async removeDomain ( id ) {
    try {
      const response = await api.delete( `/company/${id}/domain` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no CompanyController.removeDomain: ", error );
      throw error;
    }
  }

  async resolveCompanyByDomain ( domain ) {
    try {
      const response = await api.get( `/company/public/resolve`, { params: { domain } } );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no CompanyController.resolveCompanyByDomain: ", error );
      throw error;
    }
  }

  async subscribe ( id, data ) {
    try {
      const response = await api.post( `/company/${id}/subscribe`, data );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no CompanyController.subscribe: ", error );
      throw error;
    }
  }

  async cancelSubscription ( id ) {
    try {
      const response = await api.post( `/company/${id}/cancel-subscription` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no CompanyController.cancelSubscription: ", error );
      throw error;
    }
  }

}

export default new CompanyController();